export const userFileConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_USER_FILE_SUCCESS',
		REQUEST : 'GET_PAGED_USER_FILE_REQUEST',
		FAILURE : 'GET_PAGED_USER_FILE_FAILURE'
	},
	GetFile: {
		SUCCESS : 'GET_USER_FILE_SUCCESS',
		REQUEST : 'GET_USER_FILE_REQUEST',
		FAILURE : 'GET_USER_FILE_FAILURE'
	},
	Clear: 'CLEAR_USER_FILE'
}